import React from "react";
import CourseLandingPage from "../components/CourseLandingPage";
import { COURSE_1 } from "../config/iGetToCourse";

/**
 * COURSE 1 LANDING — /i-get-to-course
 * "Start Living I GET TO — Self-Guided to ACT NOW" ($8.88)
 */

const BRAND = { teal: "#068fa2", gold: "#d4af6a", mint: "#5EEAD4" };

export default function IGetToCoursePage() {
  return (
    <CourseLandingPage
      product={COURSE_1}
      showBundleCrossSell
      headline={
        <>
          Start your{" "}
          <span style={{ color: BRAND.mint, fontStyle: "italic" }}>I GET TO</span>{" "}
          journey <span style={{ color: BRAND.gold }}>tonight.</span>
        </>
      }
      whoFor={{
        eyebrow: "Who this is for",
        headlineNode: (
          <>
            You're tired. You're overstimulated.
            <br />
            <span className="italic" style={{ color: BRAND.teal }}>
              You're at your wits' end.
            </span>
          </>
        ),
        paragraphs: [
          "You don't need another big, overwhelming program. You don't need another guru promising the moon. You don't need 47 modules and a Facebook group and a six-week commitment.",
          "You need real tools, in your time. You need something doable. Something you can pick up tonight, do a page of, and feel a small shift before you fall asleep.",
          `This is that. 20 pages. 5 phases. Yours forever for ${COURSE_1.priceDisplay}.`,
        ],
      }}
      phasesTitle={
        <>
          Five phases.{" "}
          <span style={{ color: BRAND.mint, fontStyle: "italic" }}>
            Read it. Do it. Anchor it.
          </span>
        </>
      }
      includes={[
        "Short, bite-sized lessons you can read in 5-10 minutes — no video, no audio, no overwhelm.",
        `"Right now" prompts in every lesson — so you don't just read, you actually shift.`,
        `"Write it down to anchor it" journaling sections — the technique that makes the work stick.`,
        "The I GET TO reframe — the language that turns obligation into opportunity.",
        "Your daily Spiritual Hygiene practice — simple, non-negotiable, doable.",
        "A starter on Boundaries, Receiving, and finding your WHY.",
        "Progress checkboxes for every phase, so your wins are visible.",
        "Yours forever — re-read it any season, any messy middle.",
      ]}
      honestNote={
        <>
          Honest note from me: this is NOT the whole method. The full book (paperback, launching
          mid-June 2026) is the complete journey. This 20-page course is the doable, do-it-tonight
          on-ramp — designed to get you into the practice TODAY.
          <br />
          <br />
          <span style={{ color: BRAND.teal, fontStyle: "normal", fontWeight: 500 }}>
            Start here. Then keep going.
          </span>
        </>
      }
      closer={{
        headlineNode: (
          <>
            $8.88 is the price of intention.
            <br />
            <span style={{ color: BRAND.mint, fontStyle: "italic" }}>
              Tonight could be the night.
            </span>
          </>
        ),
        paragraph:
          "Download it. Read the first phase before bed. Tomorrow morning, you have a practice. Just like that.",
      }}
      metaDesc="Start your I GET TO journey tonight. A 20-page doable, self-guided on-ramp into the Mind Body Spirit HYGIENE™ Method by Temple Franklin. 5 phases. $8.88 — infinity and prosperity. Instant download."
      ldSku="MBSH-IGT-COURSE-1"
    />
  );
}
